// Build a CSV export of the cost-table options. Kept pure + separate from the
// (heavy) FinalQuoteCostTable component so it can be unit-tested. Each option
// carries { airline: { name }, cumulativeVolumeWeight, dataForCalculation:
// { finalRate, CW } }.
const CSV_HEADERS = ["Airline Name", "Volume Weight (kg)", "Final Rate (£)"];

const escCsv = (v) => {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function buildCostTableCsv(options) {
  const list = Array.isArray(options) ? options : [];
  const header = CSV_HEADERS.join(",");
  if (!list.length) return header;
  const rows = list.map((option) => {
    const name = option?.airline?.name ?? "";
    const cw =
      option?.cumulativeVolumeWeight ?? option?.dataForCalculation?.CW ?? "";
    const finalRate = option?.dataForCalculation?.finalRate ?? "";
    return [escCsv(name), escCsv(cw), escCsv(finalRate)].join(",");
  });
  return [header, ...rows].join("\n");
}
